import { useState } from "react";
import { Activity, Camera, ChevronRight, Film, LogOut, Menu, RadioTower, X } from "lucide-react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@frontend/auth/AuthProvider";
import { BrandLockup } from "@frontend/components/BrandLockup";
import { ThemeToggle } from "@frontend/theme/ThemeToggle";

const navigation = [
  { to: "/", label: "Visão geral", icon: Activity, end: true },
  { to: "/cameras", label: "Câmeras", icon: Camera },
  { to: "/collectors", label: "Coletores", icon: RadioTower },
  { to: "/frames", label: "Frames", icon: Film },
];

export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();

  const current = navigation.find((item) =>
    item.end ? location.pathname === item.to : location.pathname.startsWith(item.to),
  );

  return (
    <div className="app-shell">
      <aside className={`sidebar ${mobileOpen ? "sidebar--open" : ""}`}>
        <div className="brand">
          <BrandLockup compact />
          <button className="icon-button sidebar__close" aria-label="Fechar menu" onClick={() => setMobileOpen(false)}>
            <X size={19} />
          </button>
        </div>

        <nav className="sidebar__nav" aria-label="Navegação principal">
          {navigation.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              className={({ isActive }) => `nav-item ${isActive ? "nav-item--active" : ""}`}
              key={to}
              onClick={() => setMobileOpen(false)}
              to={to}
              {...(end ? { end: true } : {})}
            >
              <Icon size={19} />
              <span>{label}</span>
              <ChevronRight className="nav-item__arrow" size={16} />
            </NavLink>
          ))}
        </nav>

        <div className="sidebar__footer">
          <div className="sidebar-theme">
            <ThemeToggle />
            <span>Tema da interface</span>
          </div>
          <div className="user-chip">
            <span className="user-chip__avatar">{initials(user?.display_name ?? "Admin")}</span>
            <div>
              <strong>{user?.display_name}</strong>
              <span>{user?.email}</span>
            </div>
          </div>
          <button className="logout-button" onClick={() => void logout()} type="button">
            <LogOut size={17} /> Sair
          </button>
        </div>
      </aside>

      {mobileOpen ? <button aria-label="Fechar menu" className="sidebar-overlay" onClick={() => setMobileOpen(false)} /> : null}

      <div className="app-main">
        <header className="mobile-header">
          <button className="icon-button" aria-label="Abrir menu" onClick={() => setMobileOpen(true)}>
            <Menu size={21} />
          </button>
          <strong>{current?.label ?? "Bomia"}</strong>
          <ThemeToggle />
        </header>
        <main className="page-content"><Outlet /></main>
      </div>
    </div>
  );
}

function initials(name: string): string {
  return name
    .split(/\s+/u)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}
